interface UpdateItem {
  id: number;
  date: string;
  comic: string;
  chapter: string;
  tag: string;
  tagColor: string;
}

const updates: UpdateItem[] = [
  { id: 1, date: '07-28', comic: '斗破苍穹', chapter: '第438话 最终决战', tag: '热门', tagColor: 'bg-red-100 text-red-600' },
  { id: 2, date: '07-28', comic: '一人之下', chapter: '第612话 新的篇章', tag: '新番', tagColor: 'bg-green-100 text-green-600' },
  { id: 3, date: '07-28', comic: '仙王的日常生活', chapter: '第287话 灵力暴走', tag: '连载', tagColor: 'bg-blue-100 text-blue-600' },
  { id: 4, date: '07-28', comic: '咒术回战', chapter: '第243话 领域展开', tag: '热门', tagColor: 'bg-red-100 text-red-600' },
  { id: 5, date: '07-27', comic: '海贼王', chapter: '第1108话 新时代', tag: '经典', tagColor: 'bg-amber-100 text-amber-600' },
  { id: 6, date: '07-27', comic: '进击的巨人', chapter: '最终卷 特别篇', tag: '完结', tagColor: 'bg-purple-100 text-purple-600' },
  { id: 7, date: '07-27', comic: '鬼灭之刃', chapter: '外传 水之呼吸', tag: '番外', tagColor: 'bg-teal-100 text-teal-600' },
  { id: 8, date: '07-26', comic: '排球少年', chapter: '第402话 新的赛场', tag: '连载', tagColor: 'bg-blue-100 text-blue-600' },
  { id: 9, date: '07-26', comic: '约定的梦幻岛', chapter: '特别篇 回忆', tag: '番外', tagColor: 'bg-teal-100 text-teal-600' },
];

export default function Updates() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-100">
      <div className="px-4 md:px-6 max-w-[1200px] mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">更新动态</h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">每日热更漫画速递，追更不迷路</p>
        </div>

        <div className="relative hidden md:block">
          <div className="absolute left-1/2 -translate-x-1/2 top-0 bottom-0 w-px bg-background-300/60"></div>

          <div className="space-y-4">
            {updates.map((item, idx) => (
              <div
                key={item.id}
                className={`relative flex items-center ${
                  idx % 2 === 0 ? 'flex-row' : 'flex-row-reverse'
                }`}
              >
                <div className="absolute left-1/2 -translate-x-1/2 top-1/2 -translate-y-1/2 w-3 h-3 rounded-full bg-accent-500 ring-4 ring-background-100 z-10"></div>

                <div className={`flex-1 ${idx % 2 === 0 ? 'pr-16 text-right' : 'pl-16 text-left'}`}>
                  <div className="bg-background-50 rounded-xl border border-background-200/70 p-4 hover:border-primary-200 transition-all duration-200 cursor-pointer">
                    <div className={`flex items-center gap-2 mb-1.5 ${idx % 2 === 0 ? 'justify-end' : 'justify-start'}`}>
                      <span className="text-xs text-foreground-500 bg-background-100 px-2 py-0.5 rounded-full whitespace-nowrap">{item.date}</span>
                      <span className={`text-[10px] px-1.5 py-0.5 rounded-full font-medium whitespace-nowrap ${item.tagColor}`}>{item.tag}</span>
                    </div>
                    <div className={`font-semibold text-foreground-900 text-sm ${idx % 2 === 0 ? 'text-right' : 'text-left'}`}>
                      {item.comic}
                    </div>
                    <div className={`text-xs text-foreground-600 mt-0.5 ${idx % 2 === 0 ? 'text-right' : 'text-left'}`}>
                      {item.chapter}
                    </div>
                  </div>
                </div>

                <div className="w-1/2"></div>
              </div>
            ))}
          </div>
        </div>

        <div className="block md:hidden space-y-3">
          {updates.map((item) => (
            <div
              key={`mobile-${item.id}`}
              className="bg-background-50 rounded-xl border border-background-200/70 p-4 hover:border-primary-200 transition-all duration-200 cursor-pointer"
            >
              <div className="flex items-center gap-2 mb-1.5">
                <span className="text-xs text-foreground-500 bg-background-100 px-2 py-0.5 rounded-full whitespace-nowrap">{item.date}</span>
                <span className={`text-[10px] px-1.5 py-0.5 rounded-full font-medium whitespace-nowrap ${item.tagColor}`}>{item.tag}</span>
              </div>
              <div className="font-semibold text-foreground-900 text-sm">{item.comic}</div>
              <div className="text-xs text-foreground-600 mt-0.5">{item.chapter}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}